<template>
    <div class="materialDelivery">
        <div class="top">
            <img class="materialDelivery-img" src="../../../assets/images/degreeApplication/materialDelivery.png" alt="" />
        </div>
        <div class="cont">
            <h1 class="cont-title">申报材料快递</h1>
            <div class="tips">注意：每次申报的收件截止时间！！（截止日期见每学期学位申报通知文件）</div>
            <div class="text">
                纸质材料请按顺序装订成册（“学士学位申请登记表”居前）后
                <!-- <span class="color-red">通过中国邮政EMS</span> -->
                <!-- 寄继续教育学院招生及学生管理办。 -->
                <span class="color-red">通过顺丰速运，按通知要求寄送</span> 
                。
            </div>
            <!-- <div class="address">地址：重庆市南岸区学府大道66号重庆医科大学继续教育学院招生与学生管理办公室</div> -->
            <!-- <div class="contacts">联系电话：023-62652903  联系人：周老师</div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'materialDelivery',
}
</script>

<style lang="scss" scoped>
.materialDelivery{
    padding: 20px;
    .top{
        .materialDelivery-img{
            width: 150px;
            height: 100px;
            object-fit: contain;
        }
    }
    .cont{
        margin-top: 20px;
        .tips{
            font-size: 18px;
            color: red;
            font-weight: 700;
        }
        .text{
            font-size: 18px;
            font-family: FangSong;
            margin-top: 20px;
            .color-red{
                color: rgb(255, 0, 0);
            }
        }
        .address{
            font-family: FangSong;
            color: #0000ff;
            font-size: 18px;
            margin-top: 20px;
        }
        .contacts{
            font-family: FangSong;
            color: #0000ff;
            font-size: 18px;
            margin-top: 20px;
        }
    }
}
</style>